import { conflictsPalette } from "./conflictsPalette";

export const conflictsStyles = {
    backdropStyling: {
        zIndex: 101,
        color: conflictsPalette.text.white,
        top: "50px"
    }
} as const;
